import React, { useState } from "react";
import OtherStyles from "./EnterpriseOnboarding.module.scss";
import Form from "src/bepaid/components/Form";
import InputText from "src/bepaid/components/Form/controls/InputText";
import FormStyles from "src/bepaid/components/Form/CommonForm.module.scss";
import Select from "src/bepaid/components/Form/controls/Select";
import IconArrowDown from "src/bepaid/assets/images/common/drop_down_arrow_grey.svg";
import Image from "src/bepaid/components/Image";
import InputFile from "src/bepaid/components/Form/controls/InputFile";
import InputFileDropZone from "src/bepaid/components/Form/controls/InputFile/components/InputFileDropZone";
import classNames from "classnames";
import Checkbox from "antd/es/checkbox";
import Button from "src/bepaid/components/Form/controls/Button";
import { BrowserView, MobileView } from "react-device-detect";
import GuestLayout from "src/bepaid/layouts/GuestLayout";
import HeaderLogo from "src/bepaid/assets/images/desktop/header_ipaymy_logo.svg";
import ShareholderExample from "src/bepaid/assets/images/shareholder_example.png";
import { invokeMessage } from "src/bepaid/components/Message";
import { ENTERPRISE_ONBOARDING_FORM } from "src/ipm-shared/store/model/EnterpriseOnboarding/const";

const styles = {
  ...FormStyles,
  ...OtherStyles
};

export type CountryOption = {
  label: string;
  value: string;
};

export const COUNTRY_OPTIONS: CountryOption[] = [
  { label: "Singapore (SG)", value: "SG" },
  { label: "Australia (AU)", value: "AU" },
  { label: "Hong Kong (HK)", value: "HK" },
  { label: "Malaysia (MY)", value: "MY" }
];

const EnterpriseOnboarding: React.FC<any> = props => {
  const [confirmChecked, setConfirmChecked] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const { enterpriseOnboardingSubmit } = props;
  const scrollToFirstError = () => {
    setTimeout(() => {
      const errorEls = document.getElementsByClassName(
        "ant-form-item-has-error"
      );
      if (errorEls.length > 0) {
        errorEls[0].scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 100);
  };
  const onSubmit = () => {
    enterpriseOnboardingSubmit((err: any) => {
      if (!err) {
        invokeMessage(
          "success",
          "Your onboarding information has been submitted successfully!"
        );
        setSuccess(true);
      }
    }, setLoading);
    scrollToFirstError();
  };

  const renderContent = () => {
    return (
      <div className={styles.wrapper}>
        <div className={styles.wrapperForm}>
          {success ? (
            <>
              <div className={styles.section}>
                <div className={styles.sectionBody}>
                  <Form
                    name={ENTERPRISE_ONBOARDING_FORM}
                    layout="vertical"
                    requiredMark={false}
                    className={classNames(styles.form, styles.formHeader)}
                  >
                    <div className={styles.successTitle}>
                      Your onboarding information
                      <br />
                      has been submitted successfully!
                    </div>
                  </Form>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className={styles.section}>
                <div className={styles.sectionBody}>
                  <Form
                    name={ENTERPRISE_ONBOARDING_FORM}
                    layout="vertical"
                    requiredMark={false}
                    className={classNames(styles.form, styles.formHeader)}
                  >
                    <div className={styles.infoTitle}>
                      ipaymy CDD - Enterprise Onboarding
                    </div>
                    <div className={styles.infoBody}>
                      <p>
                        <b>ipaymy</b> operates across multiple jurisdictions and
                        is committed to complying with all applicable regulatory
                        and anti-money laundering requirements in the markets
                        where we conduct business.
                      </p>
                      <p>
                        To get started with ipaymy, we require certain
                        information about your company as part of our standard
                        verification process. This helps us comply with
                        applicable regulations and ensures we can provide our
                        services securely and responsibly.
                      </p>
                      <p>
                        All information provided will be handled securely and
                        used for compliance and risk management purposes.
                      </p>
                    </div>
                  </Form>
                </div>
              </div>
              <div className={styles.section}>
                <div className={styles.sectionHeader}>General</div>
                <div className={styles.sectionBody}>
                  <Form
                    name={ENTERPRISE_ONBOARDING_FORM}
                    layout="vertical"
                    requiredMark={false}
                    className={styles.form}
                  >
                    <InputText
                      name={"company_legal_name"}
                      label={"Please provide your company's full legal name."}
                      placeholder="Your answer"
                      form={ENTERPRISE_ONBOARDING_FORM}
                    />
                    <Select
                      name="country_of_incorporation"
                      placeholder="Select country"
                      form={ENTERPRISE_ONBOARDING_FORM}
                      label="Please select your company's country of incorporation/registration."
                      options={COUNTRY_OPTIONS}
                      suffixIcon={<Image src={IconArrowDown} />}
                    />
                    <InputText
                      name={"company_website"}
                      label={"Please provide your company's official website."}
                      placeholder="Your answer"
                      form={ENTERPRISE_ONBOARDING_FORM}
                    />
                    <Form.Item>
                      <div className={styles.includeTexts}>
                        <p className={styles.lead}>
                          Please provide your company's official
                          incorporation/registration document(s) dated within
                          the last 6 months, containing minimally the following
                          details:
                        </p>

                        <ol type="a">
                          <li>Full legal name of entity</li>
                          <li>Business/principal place of business</li>
                          <li>Nature of business operations</li>
                          <li>Register of Directors</li>
                          <li>Register of Shareholders</li>
                        </ol>

                        <p>
                          Type of document to provide based on country, please
                          refer to the links for samples:
                        </p>

                        <div className={styles.docLinks}>
                          <p>
                            SG:{" "}
                            <a
                              href={
                                "https://www.bizfile.gov.sg/buy-info/info-products/business-profile"
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              ACRA Bizfile
                            </a>
                          </p>
                          <p>
                            AU:{" "}
                            <a
                              href={
                                "https://download.asic.gov.au/media/ldmneiyw/current-company-extract-paid-feb-2026.pdf"
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              ASIC Current Company Extract
                            </a>
                          </p>
                          <p>
                            HK:{" "}
                            <a
                              href={
                                "https://www.cr.gov.hk/en/companies_ordinance/docs/NAR1(private)_Specimen-e.pdf"
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              CR Annual Return Form NAR1
                            </a>
                          </p>
                          <p>
                            MY:{" "}
                            <a
                              href={
                                "https://www.ssm-einfo.my/public/assets/sample/Company_Profile.pdf"
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              SSM Company Profile
                            </a>
                          </p>
                        </div>
                      </div>
                      <InputFile
                        className="upload_bank_documents"
                        allowedFileTypes={["jpg", "png", "heic", "pdf"]}
                        name="b_acra_bizfile"
                        purpose="kyc"
                        isPublic={true}
                        label="Upload Document"
                        form={ENTERPRISE_ONBOARDING_FORM}
                        canDrag={true}
                        multiple={true}
                        maxFileAmount={5}
                        renderComponent={InputFileDropZone}
                      />
                    </Form.Item>
                  </Form>
                </div>
              </div>
              <div className={styles.section}>
                <div className={styles.sectionHeader}>
                  Shareholdings & Beneficial Owners
                </div>
                <div className={styles.sectionBody}>
                  <Form
                    name={ENTERPRISE_ONBOARDING_FORM}
                    layout="vertical"
                    requiredMark={false}
                    className={styles.form}
                  >
                    <Select
                      name="parent_public_entity"
                      placeholder="Select"
                      form={ENTERPRISE_ONBOARDING_FORM}
                      label={
                        "Is your parent company a public entity listed on a regulated exchange?"
                      }
                      options={[
                        {
                          label: "Yes",
                          value: "yes"
                        },
                        {
                          label: "No",
                          value: "no"
                        }
                      ]}
                      suffixIcon={<Image src={IconArrowDown} />}
                    />

                    <InputText
                      name={"parent_company_legal_name"}
                      label={
                        "Please provide your parent company's full legal name."
                      }
                      placeholder="Your answer"
                      form={ENTERPRISE_ONBOARDING_FORM}
                    />

                    <Form.Item>
                      <div className={styles.includeTexts}>
                        <p className={styles.lead}>
                          Please provide your company’s most recent corporate
                          structure chart showing the full ownership chain up to
                          the ultimate beneficial owner(s).
                        </p>
                        <p className={styles.lead}>
                          The chart (see sample below) must:
                        </p>
                        <ol className={styles.discType}>
                          <li>Include all intermediate entities</li>
                          <li>
                            State the country of incorporation of each entity
                          </li>
                          <li>
                            Clearly indicate ownership percentages at each level
                          </li>
                          <li>
                            Drill down to the individual ultimate beneficial
                            owner(s) who directly or indirectly hold 25% or more
                            ownership or control
                          </li>
                        </ol>
                        <p className={styles.lead}>
                          If no individual meets the 25% threshold, please
                          identify the individual(s) who exercise control or the
                          senior managing official.
                        </p>
                      </div>

                      <InputFile
                        className="upload_bank_documents"
                        allowedFileTypes={["jpg", "png", "heic", "pdf"]}
                        name="b_structured_chart"
                        purpose="kyc"
                        isPublic={true}
                        label="Upload Document"
                        form={ENTERPRISE_ONBOARDING_FORM}
                        canDrag={true}
                        multiple={true}
                        maxFileAmount={5}
                        renderComponent={InputFileDropZone}
                      />

                      <div
                        className={classNames(
                          styles.includeTexts,
                          styles.docImage
                        )}
                      >
                        <Image src={ShareholderExample} />
                      </div>
                    </Form.Item>

                    <Form.Item>
                      <p className={styles.label}>
                        Please provide the Passport/National IDs of each
                        individual ultimate beneficial owner(s) who directly or
                        indirectly <b>owns or control 25% or more</b> of the
                        entity.
                      </p>
                      <p className={styles.helperText}>
                        {
                          "This is not required if your parent company is a public listed company."
                        }
                      </p>
                      <InputFile
                        className="upload_bank_documents"
                        allowedFileTypes={["jpg", "png", "heic", "pdf"]}
                        name="b_shareholder"
                        purpose="kyc"
                        isPublic={true}
                        label="Upload Document"
                        form={ENTERPRISE_ONBOARDING_FORM}
                        canDrag={true}
                        multiple={true}
                        maxFileAmount={5}
                        renderComponent={InputFileDropZone}
                      />
                    </Form.Item>

                    <Form.Item>
                      <p className={styles.label}>
                        Please provide a copy of a utility bill, bank statement,
                        or other document (dated within the last 3 months) as a
                        proof of address for each individual ultimate beneficial
                        owner(s) who directly or indirectly{" "}
                        <b>owns or controls 25% or more</b> of the entity.
                      </p>
                      <p className={styles.helperText}>
                        This is not required if your parent company is a public
                        listed company.
                      </p>
                      <InputFile
                        className="upload_bank_documents"
                        allowedFileTypes={["jpg", "png", "heic", "pdf"]}
                        name="b_shareholder_poa"
                        purpose="kyc"
                        isPublic={true}
                        label="Upload Document"
                        form={ENTERPRISE_ONBOARDING_FORM}
                        canDrag={true}
                        multiple={true}
                        maxFileAmount={5}
                        renderComponent={InputFileDropZone}
                      />
                    </Form.Item>

                    <Form.Item>
                      <div className={styles.includeTexts}>
                        <p className={styles.lead}>
                          If a trust forms part of the ownership structure or is
                          a beneficial owner, please provide a copy of the Trust
                          Deed. The document should clearly state:
                        </p>

                        <ol type="a">
                          <li>Full name of the trust</li>
                          <li>Full legal name of the trustee(s)</li>
                          <li>Type of trust</li>
                          <li>Country of establishment</li>
                          <li>Full name of the settlor</li>
                        </ol>

                        <p>
                          Please note that additional information may be
                          requested where required for regulatory or compliance
                          purposes.
                        </p>
                      </div>

                      <InputFile
                        className="upload_bank_documents"
                        allowedFileTypes={["jpg", "png", "heic", "pdf"]}
                        name="b_shareholder_corporate"
                        purpose="kyc"
                        isPublic={true}
                        label="Upload Document"
                        form={ENTERPRISE_ONBOARDING_FORM}
                        canDrag={true}
                        multiple={true}
                        maxFileAmount={5}
                        renderComponent={InputFileDropZone}
                      />
                    </Form.Item>
                  </Form>
                </div>
              </div>
              <div className={styles.section}>
                <div className={styles.sectionHeader}>
                  Persons Authorised to Act on Behalf of Entity
                </div>
                <div className={styles.sectionBody}>
                  <Form
                    name={ENTERPRISE_ONBOARDING_FORM}
                    layout="vertical"
                    requiredMark={false}
                    className={styles.form}
                  >
                    <Form.Item>
                      <div className={styles.includeTexts}>
                        <p className={styles.lead}>
                          Please provide details of natural persons authorized
                          to act (NP2A)/persons purporting to act
                          (PPTA)/authorised representative (AR) on behalf of the
                          entity.
                        </p>
                        <ul className={styles.np2aList}>
                          <li>- Board Resolution appointing NP2A; OR</li>
                          <li>
                            - Letter of Authorisation{" "}
                            <a
                              href={
                                "https://s3-ap-southeast-1.amazonaws.com/ipaymy.com/docs/ipaymy+LOA+Template.docx"
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              (template)
                            </a>
                          </li>
                        </ul>
                        <p className={styles.lead}>
                          The minimum information required for each individual
                          NP2A/PPTA/AR would be: (i) Full Legal Name; (ii)
                          Unique Identification Number; (iii) Residential
                          Address; (iv) Email Address; and (v) Role/Title
                          (Director/Controller/Finance Manager, etc).
                        </p>
                      </div>

                      <InputFile
                        className="upload_bank_documents"
                        allowedFileTypes={["jpg", "png", "heic", "pdf"]}
                        name="b_letter_of_authorization"
                        purpose="kyc"
                        isPublic={true}
                        label="Upload Document"
                        form={ENTERPRISE_ONBOARDING_FORM}
                        canDrag={true}
                        multiple={true}
                        maxFileAmount={5}
                        renderComponent={InputFileDropZone}
                      />
                    </Form.Item>
                    <Form.Item>
                      <p className={styles.label}>
                        Please provide the Passport/National ID for each
                        NP2A/PPTA/AR name stated in the Board Resolution or
                        Letter of Authorisation.
                      </p>
                      <InputFile
                        className="upload_bank_documents"
                        allowedFileTypes={["jpg", "png", "heic", "pdf"]}
                        name="b_np2a_nric"
                        purpose="kyc"
                        isPublic={true}
                        label="Upload Document"
                        form={ENTERPRISE_ONBOARDING_FORM}
                        canDrag={true}
                        multiple={true}
                        maxFileAmount={5}
                        renderComponent={InputFileDropZone}
                      />
                    </Form.Item>
                  </Form>
                </div>
              </div>
              <div className={styles.section}>
                <div className={styles.sectionHeader}>Attestation</div>
                <div className={styles.sectionBody}>
                  <Form
                    name={ENTERPRISE_ONBOARDING_FORM}
                    layout="vertical"
                    requiredMark={false}
                    className={styles.form}
                  >
                    <InputText
                      type={"textarea"}
                      name={"attestation_representative_name"}
                      placeholder="Tell us more"
                      form={ENTERPRISE_ONBOARDING_FORM}
                      defaultValue={""}
                      label={"Please provide your full legal name"}
                    />
                    <InputText
                      type={"textarea"}
                      name={"attestation_representative_designation"}
                      placeholder="Tell us more"
                      form={ENTERPRISE_ONBOARDING_FORM}
                      defaultValue={""}
                      label={
                        "Please provide your designation within the company."
                      }
                    />
                  </Form>
                </div>
              </div>
              <div
                className={classNames(styles.section, styles.confirmSection)}
              >
                <Checkbox
                  className={styles.checkbox}
                  checked={confirmChecked}
                  onChange={(e: any) => setConfirmChecked(e.target.checked)}
                >
                  <p>
                    I confirm that I am authorized to complete this form on
                    behalf of the company, and that the information provided is
                    complete, true, and accurate.
                  </p>

                  <p>
                    We acknowledge that <b>ipaymy</b> may also reach out to
                    obtain further information for verification purposes (e.g.
                    National IDs, business operating model).
                  </p>
                </Checkbox>
              </div>
              <div className={styles.section}>
                <Button
                  id={"ipaymy_btn_checkout_payment"}
                  wrapperClassName={styles.wrapperButton}
                  type="primary"
                  htmlType="submit"
                  loading={!confirmChecked || loading}
                  onClick={onSubmit}
                >
                  {loading ? "Submitting..." : "Submit"}
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const renderDesktopView = () => {
    return <div className={styles.wrapperDesktop}>{renderContent()}</div>;
  };

  return (
    <GuestLayout header={<Image src={HeaderLogo} />} isEnterpriseOnboarding>
      <BrowserView>{renderDesktopView()}</BrowserView>
      <MobileView>{renderContent()}</MobileView>
    </GuestLayout>
  );
};

export default EnterpriseOnboarding;
